/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_AddInputs */

const vi_shop_group_add = /** @type {(inputs: Shop_Group_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm nhóm`)
};

/**

* @param {Shop_Group_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_add = /** @type {((inputs?: Shop_Group_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_add(inputs)
});